import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "63",
  height: "63",
  viewBox: "0 0 63 63",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M31.5 0C14.103 0 0 14.103 0 31.5C0 48.897 14.103 63 31.5 63C48.897 63 63 48.897 63 31.5C63 14.103 48.897 0 31.5 0Z",
  fill: "#E26B82"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "18",
  y: "21.5356",
  width: "5",
  height: "32",
  rx: "2.5",
  transform: "rotate(-45 18 21.5356)",
  fill: "white"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  width: "5",
  height: "32",
  rx: "2.5",
  transform: "matrix(-0.707107 -0.707107 -0.707107 0.707107 44.1631 21.5356)",
  fill: "white"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default render